<style>

.card{
  position: relative;
  color: white;
}

img{
  object-fit: cover;
  width: 100%;
}
.starts-in {
  position: absolute;
  top: 5px;
  left: 5px;
  padding: 5px;
  background-color: rgba(0,0,0,0.8);
}
.info{
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  padding: 5px;
  /* border: 1px red solid; */
  /* margin-top: -40px; */
  background-color: rgba(0,0,0,0.8);
}

.body{
  margin: 0 10px;
}
.name{
  font-size: 21px;
}

.posted-by{
  font-size: 14px;
  margin: 10px 0 20px 0;
}

.rsvp{
  font-size: 14px;
  margin: 20px 0 20px 0;
}

.views{
  font-size: 14px;
  margin: 10px 0;
}

.youll-like{
  font-size: 19px;
  font-family: Sansation;
  font-style: italic;
  margin: 30px 0;
}

.groups{
  position: relative;
  text-align: center;
  color: white;
  margin: 25px;
}
.groups-text{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0,0,0,0.7);
  font-family: Sansation;
  font-size: 21px;
}
.group-img{
  object-fit: scale-down;
  width: 100%;
}
</style>

<Header 
back="{true}"
buttons="{ [ {icon: 'icon-calendar_add', text: 'Add Event', callback: 'addEvent', disabled: false, }, ] }"
on:addEvent="{ () => push('/create-new-event') }"
on:back="{ () => { pop() } }">Event Info</Header>
<div class="has-header"></div>

<div class="card">
  <img src="{item.img}" alt="" class="img">
  <div class="starts-in"><StartsIn currentTime="{currentTime}" startsAt="{item.startsAt}" endsAt="{item.endsAt}"></StartsIn></div>
  <div class="info">
    <div><Stars stars="{item.stars}"></Stars></div>
    <div><EventTime startsAt="{item.startsAt}" endsAt="{item.endsAt}"></EventTime></div>
  </div>
</div>

<div class="body">
  <div class="name">{item.name}</div>
  <div class="posted-by">posted by <a href="/business-profile/123" use:link>The Grove Bar and Restaurant</a></div>
  
  <div class="im-going"> <button> <i class="icon-check"></i> I'm Going</button> </div>
  
  <div class="rsvp">Rose Alibaster +5 others are going</div>
  
  <InfoBox icon="phone">213-000-0000</InfoBox>
  <InfoBox icon="address">1234 Main St<br>Los Angeles, CA 90000</InfoBox>
  <InfoBox icon="price">$5 Cover, $2 Shot Specials</InfoBox>
  <InfoBox icon="website">thegrovela.com</InfoBox>
  <InfoBox icon="facebook">f/TheGrove</InfoBox>
  <InfoBox icon="instagram">@TheGrove</InfoBox>
  <InfoBox icon="linkedin">@TheGrove</InfoBox>
  <InfoBox icon="snapchat">@TheGrove</InfoBox>
  <InfoBox icon="twitter">@TheGrove</InfoBox>
  
  <h3>Description</h3>
  
  <div class="description">
    Come join us for all you can drink cocktails with live music this Friday night at the Grove!! $5 entry fee, 50% off all drinks from 8pm-12am. Come on in!
  </div>
  
  <div class="views">
    1,000 people have looked at this today
  </div>
  
  <!-- <div class="youll-like">Groups we think you'll like based on this event</div> -->
  
</div>

<!-- <div class="groups">
  <img src="/i/new-mexico-wine-tasting.jpg" class="group-img">
  <div class="groups-text">
    New Mexico Wine Tasting
  </div>
</div>

<div class="groups">
  <img src="/i/raver-babies.jpg" class="group-img">
  <div class="groups-text">
    Albuquerque Raver Babies
  </div>
</div> -->


<div class="has-action-bar"></div>
<ActionBar></ActionBar>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';
export let params = {};

import Header from "../components/Header.svelte";
import Stars from "../components/Stars.svelte";
import EventTime from "../components/EventTime.svelte";
import StartsIn from "../components/StartsIn.svelte";
import InfoBox from "../components/InfoBox.svelte";
import ActionBar from "../components/ActionBar.svelte";

let interval = null;
let currentTime =  Math.round( Date.now() / 1000 );
import { onMount } from "svelte";
onMount(async () => {
  // update the event times every X minutes
  interval = setInterval( () => { currentTime =  Math.round( Date.now() / 1000 ) }, 1000 * 60 * 1);
});

let date = Math.round( Date.now() / 1000 );

let item = {oid: "abc01def", name: "Cocktail Night At The Grove - $5 Cover", stars: 4.5, startsAt: date + 120, endsAt: date + 180, img: "/i/event1.jpg"};

</script>